import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    action: String,
    targetSgid: String,
    startUrl: String,
    verifyUrl: String
  }

  async start(event) {
    event.preventDefault()
    this.triggerEl = event.currentTarget
    const csrf = document.querySelector('meta[name="csrf-token"]')?.content
    const resp = await fetch(this.startUrlValue, {
      method: "POST",
      body: new URLSearchParams({
        action_name: this.actionValue,
        target_sgid: this.targetSgidValue,
        authenticity_token: csrf || ""
      }),
      headers: { "Accept": "application/json" }
    })
    if (!resp.ok) {
      console.error("manager-approval start failed", await resp.text())
      return
    }
    const { challenge_token } = await resp.json()
    this.challengeToken = challenge_token
    this.openModal()
  }

  openModal() {
    this.modal = document.getElementById("manager-approval-modal")
    if (!this.modal) return
    this.modal.classList.remove("hidden")
    this.modal.classList.add("flex")
    const tiles = this.modal.querySelector('[data-pin-keypad-target="tiles"]')
    const panel = this.modal.querySelector('[data-pin-keypad-target="panel"]')
    if (tiles) tiles.hidden = false
    if (panel) panel.hidden = true

    const keypadEl = this.modal.querySelector('[data-controller~="pin-keypad"]')
    const kp = this.application.getControllerForElementAndIdentifier(keypadEl, "pin-keypad")
    if (!kp) return

    kp.maybeSubmit = async () => {
      if (!kp.membershipIdValue) return
      const csrf = document.querySelector('meta[name="csrf-token"]')?.content
      const body = new URLSearchParams({
        challenge_token: this.challengeToken,
        membership_id: kp.membershipIdValue,
        pin: kp.pin,
        authenticity_token: csrf || ""
      })
      const r = await fetch(this.verifyUrlValue, {
        method: "POST", body, headers: { "Accept": "application/json" }
      })
      if (!r.ok) {
        const errEl = this.modal.querySelector('[data-testid="manager-approval-error"]')
        const { error } = await r.json().catch(() => ({ error: "Wrong PIN" }))
        if (errEl) {
          errEl.textContent = error
          errEl.classList.remove("hidden")
        }
        kp.pin = ""
        kp.render()
        return
      }
      const { approval_token } = await r.json()
      this.closeModal()
      this.triggerEl?.dispatchEvent(new CustomEvent("manager-approval:approved", {
        detail: { approvalToken: approval_token, action: this.actionValue, targetSgid: this.targetSgidValue },
        bubbles: true
      }))
    }
  }

  closeModal() {
    this.modal?.classList.add("hidden")
    this.modal?.classList.remove("flex")
  }
}
